'use client';

import { c as _c } from "react/compiler-runtime";
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { LiveCacheItem } from '@module/apis/client-side/main/type';
import limitArraySize from '@module/helpers/sidebar/limitArraySize';
import { cn } from '@module/lib/utils';
import { useFetchWebMainInfoQuery } from '@module/queries/main/mainQueryHooks';
import useGoPlay from '@pc/hooks/play/useGoPlay';
import { usePathname, useRouter } from 'next/navigation';
import { useState } from 'react';
import BJListItem from './BJListItem';
import BJRankingLoading from './BJRankingLoading';
type BJRankingType = 'personal' | 'total';
function BJRankingContainer() {
  const $ = _c(37);
  const router = useRouter();
  const pathName = usePathname();
  let t0;
  if ($[0] !== pathName) {
    t0 = pathName.split("/");
    $[0] = pathName;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const splitPath = t0;
  const mediaId = splitPath[splitPath.length - 1];
  const {
    data: mainInfo,
    isLoading
  } = useFetchWebMainInfoQuery();
  const [rankingType, setRankingType] = useState("personal");
  const [openPanelMap, setOpenPanelMap] = useState(false);
  const baseRankList = rankingType === "personal" ? mainInfo?.bjPersonalRank || [] : mainInfo?.bjRank || [];
  const bjRankList = limitArraySize({
    array: baseRankList,
    shouldExpand: openPanelMap
  });
  const {
    goPlay
  } = useGoPlay();
  const scrollTopHandler = _temp;
  let t1;
  if ($[2] !== goPlay || $[3] !== mediaId || $[4] !== router) {
    t1 = item => {
      if (mediaId === item.userId) {
        scrollTopHandler();
        return;
      }
      if (!item.media) {
        router.push(`/channel/${item.userId}/notice`);
        return;
      }
      goPlay(item.media);
    };
    $[2] = goPlay;
    $[3] = mediaId;
    $[4] = router;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleRankingItemClick = t1;
  if (isLoading) {
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <BJRankingLoading />;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  const t2 = "border-borderBg01 border-b pt-[17px] pb-[20px]";
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h2 className="flex-1 text-left font-medium text-[15px] leading-[21px] tracking-[-0.5px]">{"BJ\uB7AD\uD0B9"}</h2>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = rankingType === "personal";
  const t5 = rankingType !== "personal";
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = cn("px-[10px] text-center text-[13px] leading-[19px] tracking-[-0.5px]", {
      "font-bold text-baseFg": t4,
      "font-medium text-colorFg03": t5
    });
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setRankingType("personal");
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6) {
    t8 = <button type="button" className={t6} onClick={t7}>{"\uAC1C\uC778"}</button>;
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="h-[16px] w-px bg-borderBg07" />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = rankingType === "total";
  const t11 = rankingType !== "total";
  let t12;
  if ($[15] !== t10 || $[16] !== t11) {
    t12 = cn("pl-[10px] text-center text-[13px] leading-[19px] tracking-[-0.5px]", {
      "font-bold text-baseFg": t10,
      "font-medium text-colorFg03": t11
    });
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => {
      setRankingType("total");
    };
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t12) {
    t14 = <button type="button" className={t12} onClick={t13}>{"\uC804\uCCB4"}</button>;
    $[19] = t12;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t14 || $[22] !== t8) {
    t15 = <div className="flex w-full items-center justify-between px-[23px]">{t3}<div className="flex items-center py-px">{t8}{t9}{t14}</div></div>;
    $[21] = t14;
    $[22] = t8;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  const t16 = "flex flex-col gap-[10px] px-[8px] pt-[5px]";
  let t17;
  if ($[24] !== handleRankingItemClick) {
    t17 = item_0 => {
      const isLive = !!item_0.media?.isLive;
      const isRT = item_0.media?.latencyMode === "RT";
      return <BJListItem key={item_0.userIdx} isLive={isLive} isRT={isRT} onClick={() => handleRankingItemClick(item_0)} title={item_0.media?.title || item_0.channelTitle} userImg={item_0.userImg} userNick={item_0.userNick} />;
    };
    $[24] = handleRankingItemClick;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  const t18 = bjRankList.map(t17);
  let t19;
  if ($[26] !== t18) {
    t19 = <ul>{t18}</ul>;
    $[26] = t18;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== baseRankList.length || $[29] !== openPanelMap) {
    t20 = baseRankList.length > 5 && <button type="button" className="flex h-[26px] w-full items-center gap-[30px] px-[25px] text-left text-[15px] leading-[21px] tracking-[-0.5px]" aria-expanded="false" onClick={() => {
      setOpenPanelMap(_temp2);
    }}>{openPanelMap ? <FontAwesomeIcon icon={faChevronUp} className="h-[10px] w-[10px] shrink-0" /> : <FontAwesomeIcon icon={faChevronDown} className="h-[10px] w-[10px] shrink-0" />}<span>{openPanelMap ? "\uAC04\uB7B5\uD788 \uBCF4\uAE30" : `${baseRankList.length - 5}${"\uAC1C \uB354\uBCF4\uAE30"}`}</span></button>;
    $[28] = baseRankList.length;
    $[29] = openPanelMap;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== t19 || $[32] !== t20) {
    t21 = <div className={t16}>{t19}{t20}</div>;
    $[31] = t19;
    $[32] = t20;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== t15 || $[35] !== t21) {
    t22 = <div className={t2}>{t15}{t21}</div>;
    $[34] = t15;
    $[35] = t21;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  return t22;
}
function _temp2(prev) {
  return !prev;
}
function _temp() {
  if (typeof window === "undefined") {
    return;
  }
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}
export default BJRankingContainer;